import React from 'react';
import './CoFounders.css'; // Optional: Add styles in a separate CSS file

const CoFounders = ({ founders }) => {
  return (
        <div className="cofounders-container">
        {founders.map((founder, index) => (
            <div key={index} className="founder-card">
            <img
                src={founder.image}
                alt={`${founder.name}'s portrait`}
                className="founder-image"
            />
            <h3 className="founder-name">{founder.name}</h3>
            <p className="founder-title">{founder.title}</p>
            </div>
      ))}
    </div>
  );
};

export default CoFounders;